import React from 'react'
//Helpers
import { getCover, getDescription, getQuality } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperty from '@hooks/useQueryProperty'
import { RealEstateDataPageComponentData } from 'types'

const AboutProperty_2 = ({
  propertyID,
  global_data,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  return (
    <section
      id="Descripcion"
      className={'ficha-about p-y-config prop b ' + (isLoading ? 'skeleton' : '')}
    >
      <Container fluid>
        <Row className="no-gutters">
          <Col
            lg={6}
            className="py-lg-5"
          >
            <h2 className="mb-4 pt-lg-4 mb-lg-0">Descripción de la propiedad</h2>
            <div className={'description-ficha '}>
              {allPropertyData &&
                getDescription(allPropertyData?.description, 9999).map((description, index) => (
                  <p
                    className="d-inline"
                    key={index}
                  >
                    {description}
                    {index > 0 && <br />}
                  </p>
                ))}
            </div>
          </Col>
          <Col
            lg={6}
            className={isLoading ? 'skeleton' : ''}
          >
            <img
              src={getQuality(getCover(allPropertyData?.photos))}
              alt=""
            />
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutProperty_2
